export default "__VITE_ASSET__BJkMAPPj__"